export const LOAD_MOVIES = 'LOAD_MOVIES'
export const LOAD_MOVIES_DONE = 'LOAD_MOVIES_DONE'
export const LOAD_MOVIES_ERROR = 'LOAD_MOVIES_ERROR'

export const SELECT_MOVIE = 'SELECT_MOVIE'
export const DESELECT_MOVIE = 'DESELECT_MOVIE'

export const LOAD_GENRES = 'LOAD_GENRES'
export const LOAD_GENRES_DONE = 'LOAD_GENRES_DONE'
export const LOAD_GENRES_ERROR = 'LOAD_GENRES_ERROR'

export const CHANGE_LIST = 'CHANGE_LIST'

export const SEARCH_MOVIES = 'SEARCH_MOVIES'
export const SEARCH_MOVIES_DONE = 'SEARCH_MOVIES_DONE'
export const SEARCH_MOVIES_ERROR = 'SEARCH_MOVIES_ERROR'